class DragSnap extends Konva.Group {
  constructor(config) {
    super(config);

    this.app = config.app;
    this.GUIDELINE_OFFSET = 10;

    console.log("DragSnap", this.app);

    // Drag move handler
    this.app.getLayer().on('dragmove', (e) => {
      //console.log("dragmove", e.target);
      const target = e.target;
      //if (target.name() !== 'object') return;
      //console.log("dragmove name", target.name());

      // Remove old guidelines
      this.app.getLayer().find('.guid-line').forEach((l) => l.destroy());

      const lineGuideStops = this.getLineGuideStops(target);
      const itemBounds = this.getObjectSnappingEdges(target);
      const guides = this.getGuides(lineGuideStops, itemBounds);

      //console.log("dragmove", e.target, lineGuideStops, itemBounds, guides);

      if (guides.length) {
        this.drawGuides(guides, this.app.getLayer());

        // Snap position
        const absPos = target.absolutePosition();
        guides.forEach((lg) => {
          if (lg.orientation === 'V') absPos.x = lg.lineGuide + lg.offset;
          else if (lg.orientation === 'H') absPos.y = lg.lineGuide + lg.offset;
        });
        target.absolutePosition(absPos);
      }

      this.app.getLayer().batchDraw();
    });

    // Clean up guidelines on drag end
    this.app.getLayer().on('dragend', () => {
      this.app.getLayer().find('.guid-line').forEach((l) => l.destroy());
      this.app.getLayer().batchDraw();
    });


  }


  // Collect all possible guide lines (stage borders, center, and all object edges/centers)
  getLineGuideStops(skipShape) {
    const vertical = [0, this.app.getStage().width() / 2, this.app.getStage().width()];
    const horizontal = [0, this.app.getStage().height() / 2, this.app.getStage().height()];

    //this.app.getStage().find('.object').forEach((guideItem) => {
    this.app.getSortableNodes().forEach((guideItem) => {
      if (guideItem === skipShape) return;
      const box = guideItem.getClientRect();
      vertical.push(box.x, box.x + box.width, box.x + box.width / 2);
      horizontal.push(box.y, box.y + box.height, box.y + box.height / 2);
    });

    return { vertical: vertical.flat(), horizontal: horizontal.flat() };
  }

  // Snapping edges/center of the dragged node
  getObjectSnappingEdges(node) {
    const box = node.getClientRect();
    const absPos = node.absolutePosition();

    return {
      vertical: [
        { guide: Math.round(box.x), offset: Math.round(absPos.x - box.x), snap: 'start' },
        { guide: Math.round(box.x + box.width / 2), offset: Math.round(absPos.x - box.x - box.width / 2), snap: 'center' },
        { guide: Math.round(box.x + box.width), offset: Math.round(absPos.x - box.x - box.width), snap: 'end' },
      ],
      horizontal: [
        { guide: Math.round(box.y), offset: Math.round(absPos.y - box.y), snap: 'start' },
        { guide: Math.round(box.y + box.height / 2), offset: Math.round(absPos.y - box.y - box.height / 2), snap: 'center' },
        { guide: Math.round(box.y + box.height), offset: Math.round(absPos.y - box.y - box.height), snap: 'end' },
      ],
    };
  }

  // Find closest guides within tolerance
  getGuides(lineGuideStops, itemBounds) {
    const resultV = [];
    const resultH = [];

    lineGuideStops.vertical.forEach((lineGuide) => {
      //console.log("lineGuide", lineGuide);
      itemBounds.vertical.forEach((itemBound) => {
        const diff = Math.abs(lineGuide - itemBound.guide);
        //console.log("itemBound", itemBound, diff);
        if (diff < this.GUIDELINE_OFFSET) {
          //console.log("getGuides diff found");
          resultV.push({
            lineGuide,
            diff,
            snap: itemBound.snap,
            offset: itemBound.offset,
          });
        }
      });
    });

    lineGuideStops.horizontal.forEach((lineGuide) => {
      itemBounds.horizontal.forEach((itemBound) => {
        const diff = Math.abs(lineGuide - itemBound.guide);
        if (diff < this.GUIDELINE_OFFSET) {
          resultH.push({
            lineGuide,
            diff,
            snap: itemBound.snap,
            offset: itemBound.offset,
          });
        }
      });
    });

    //console.log("getGuides", lineGuideStops, itemBounds, resultV, resultH);

    // Pick the closest vertical and horizontal guide
    const minV = resultV.sort((a, b) => a.diff - b.diff)[0];
    const minH = resultH.sort((a, b) => a.diff - b.diff)[0];

    const guides = [];
    if (minV) guides.push({ lineGuide: minV.lineGuide, offset: minV.offset, orientation: 'V' });
    if (minH) guides.push({ lineGuide: minH.lineGuide, offset: minH.offset, orientation: 'H' });

    return guides;
  }

  // Draw temporary dashed guidelines
  drawGuides(guides, layer) {
    guides.forEach((lg) => {
      if (lg.orientation === 'H') {
        const line = new Konva.Line({
          points: [-6000, 0, 6000, 0],
          stroke: '#008000',
          strokeWidth: 4,
          name: 'guid-line',
          dash: [4, 6],
        });
        this.app.getLayer().add(line);
        line.absolutePosition({ x: 0, y: lg.lineGuide });
      } else if (lg.orientation === 'V') {
        const line = new Konva.Line({
          points: [0, -6000, 0, 6000],
          stroke: '#008000',
          strokeWidth: 4,
          name: 'guid-line',
          dash: [4, 6],
        });
        this.app.getLayer().add(line);
        line.absolutePosition({ x: lg.lineGuide, y: 0 });
      }
    });
  }

}
